export const FileTypes = {
  pdf: { type: 'pdf', mediaType: 'application/pdf' },
  xlsx: { type: 'xlsx', mediaType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' },
  xml: { type: 'xml', mediaType: 'application/xml' }
};

export interface FileType {
  type: string;
  mediaType: string;
}

export interface FileUploaded {
  id: string;
  name: string;
  type: string;
  attachedOn: string;
}
